var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCategoriesAdmin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadows--inject-48"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M286.32,389.38c-20.53-11.86-53.72-11.86-74.12,0s-20.29,31.08.24,42.93,53.72,11.86,74.13,0S306.86,401.24,286.32,389.38Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.19,331.63l-9-5.2,0,0,3.52-2a3.79,3.79,0,0,0,0-6.56l-11.31-6.54a11.35,11.35,0,0,0-11.37,0L70.19,376.92a3.8,3.8,0,0,0,0,6.56l11.29,6.62a11.36,11.36,0,0,0,11.44,0l10.81-6.24,8.9,5.23a9.1,9.1,0,0,0,9.11,0l90.48-52.3A3,3,0,0,0,212.19,331.63Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.45,237.4c9.61,5.55,9.66,14.54.11,20.09s-25.08,5.55-34.7,0-9.66-14.54-.11-20.09S264.83,231.85,274.45,237.4Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.61,348.69l-47.52-27.43a2.11,2.11,0,0,1,0-3.65L380,293.27a2.1,2.1,0,0,1,2.11,0l48.58,28.05a2.1,2.1,0,0,1,0,3.64l-40.83,23.73A4.19,4.19,0,0,1,385.61,348.69Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Window--inject-48"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "373.24 82.36 372.97 188.54 378.36 191.66 378.64 85.47 373.24 82.36",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "378.64 85.47 378.64 85.47 378.36 191.66 383.06 188.93 383.31 88.17 378.64 85.47",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 375.94,
    y: 80.8,
    height: 6.23,
    transform: "translate(115.3 367.53) rotate(-60)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "378.63 89.83 378.64 85.47 373.24 82.36 373.23 86.71 378.63 89.83 378.63 89.83",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "378.63 89.83 382.41 87.65 378.64 85.47 378.64 85.47 378.63 89.83",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 375.94,
    y: 80.8,
    height: 6.23,
    transform: "translate(115.29 367.53) rotate(-60)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "308.31 44.87 313 42.14 312.72 148.32 308.03 151.05 308.31 44.87",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "308.03 151.05 312.72 148.32 448 226.43 443.31 229.15 308.03 151.05",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.93,35.55,449,119.88l-.31,118.59L302.62,154.13Zm140.38,193.6L443.59,123,308.3,44.86,308,151.05l135.28,78.1",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "302.93 35.55 307.62 32.82 453.69 117.16 449 119.88 302.93 35.55",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "449 119.88 453.69 117.16 453.38 235.74 448.69 238.47 449 119.88",
    style: {
      fill: "#f0f0f0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Table--inject-48"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M259.37,171h-4.43c0,19,.69,81.61.69,81.61h0a.79.79,0,0,0,.45.62,2.33,2.33,0,0,0,2.15,0,.75.75,0,0,0,.45-.62h0S259.37,190,259.37,171Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.44,162.37H246c-3.8,19.68-6.27,81.62-6.27,81.62h0a.76.76,0,0,0,.45.62,2.39,2.39,0,0,0,2.15,0,.75.75,0,0,0,.44-.62h0S247,181.77,250.44,162.37Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.87,162.37h4.42c3.8,19.68,6.27,81.62,6.27,81.62h0a.76.76,0,0,1-.45.62,2.39,2.39,0,0,1-2.15,0,.77.77,0,0,1-.44-.62h0S267.33,181.77,263.87,162.37Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281,161.81h-.47c-.9-2.59-3.08-5.06-6.56-7.07-9.32-5.38-24.38-5.38-33.64,0-3.45,2-5.61,4.47-6.48,7.06h-.44v2.68h0c0,3.53,2.37,7,7,9.75,9.32,5.38,24.38,5.38,33.64,0,4.63-2.69,6.94-6.21,6.92-9.74h0Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.92,152.07c9.33,5.38,9.38,14.1.11,19.49s-24.32,5.38-33.64,0-9.37-14.11-.11-19.49S264.6,146.68,273.92,152.07Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.83,144.1H245.48c0,7.68,3.58,14.18,4.69,16.11,0,.09.09.17.14.26l.06.09h0A4.86,4.86,0,0,0,252,162a11.29,11.29,0,0,0,10.28,0,4.3,4.3,0,0,0,1.88-1.92C265.34,158.1,268.83,151.67,268.83,144.1Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.38,139.32c4.58,2.64,4.6,6.93.06,9.57s-11.94,2.64-16.51,0-4.6-6.93-.06-9.57S260.81,136.68,265.38,139.32Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.89,141.09a33.53,33.53,0,0,0-3.37-14.42,12.42,12.42,0,0,1-1.59-4.39c-.11-1.56.75-3.33,2.29-3.64a3.25,3.25,0,0,1,3.14,1.5,9.29,9.29,0,0,1,1.25,3.45c1.15,5.41,2.11,11,1.39,16.44a6.77,6.77,0,0,1-.38,1.85,1.73,1.73,0,0,1-1.33,1.06,1.28,1.28,0,0,1-1.06-.41A2.69,2.69,0,0,1,255.89,141.09Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.17,141.53h0a.19.19,0,0,1-.18-.2,41.71,41.71,0,0,0-3.47-20.47.2.2,0,0,1,.1-.26.19.19,0,0,1,.25.1,42.13,42.13,0,0,1,3.51,20.66A.2.2,0,0,1,257.17,141.53Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.53,133c-1-.63-2.2-1.32-2.52-2.49a2.67,2.67,0,0,1,1.19-2.78,4,4,0,0,1,3.12-.43,8.59,8.59,0,0,1,2.88,1.45,19.13,19.13,0,0,1,4,3.78,20.58,20.58,0,0,1,3.17,5.7,23.06,23.06,0,0,1,1.14,4.1c.17,1.11.5,2.95-.65,3.67a1.66,1.66,0,0,1-1.68,0,3,3,0,0,1-1.14-1.32,15.6,15.6,0,0,1-.6-1.66,15.65,15.65,0,0,0-3.55-5.82A26.52,26.52,0,0,0,244.53,133Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.31,144.62h0a.24.24,0,0,1-.28-.18A22.85,22.85,0,0,0,244,129a.23.23,0,0,1,.21-.42,23.35,23.35,0,0,1,12.3,15.8A.23.23,0,0,1,256.31,144.62Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.38,130.57c.83-.87,1.79-1.83,1.8-3a2.67,2.67,0,0,0-1.86-2.4,4,4,0,0,0-3.12.39,8.45,8.45,0,0,0-2.42,2.12,19.76,19.76,0,0,0-2.87,4.66,20.29,20.29,0,0,0-1.61,6.32,22.42,22.42,0,0,0-.07,4.26c.12,1.11.26,3,1.55,3.38a1.66,1.66,0,0,0,1.62-.45,2.85,2.85,0,0,0,.77-1.56,13,13,0,0,0,.17-1.76,15.49,15.49,0,0,1,2-6.53A25.76,25.76,0,0,1,267.38,130.57Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.93,144.84h0a.22.22,0,0,0,.22-.24,22.9,22.9,0,0,1,7.74-18,.24.24,0,0,0,0-.33.25.25,0,0,0-.33,0,23.34,23.34,0,0,0-7.9,18.4A.22.22,0,0,0,258.93,144.84Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--side-table--inject-48"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "346.64 316.64 342.49 319.05 342.5 314.25 346.64 316.64",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "342.6 290.98 342.6 290.93 342.6 290.93 342.6 290.93 342.6 290.98",
    style: {
      fill: "#787878"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 362.82,
    y: 279.25,
    height: 46.7,
    style: {
      fill: "#cfcfcf"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "342.67 267.58 383.11 290.94 383.11 290.94 342.67 267.58",
    style: {
      fill: "#cfcfcf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.64,316.64l36.38,21v4.81l4.32,2.5.16-56.51-49.17-28.39-.16,56.5,4.33,2.5v-4.8Zm36.42-7.38-40.44-23.35.05-18.33,40.44,23.36h0ZM383,332.6l-40.44-23.35L342.6,291v-.05h0l40.45,23.35h0Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "342.55 309.25 342.6 290.98 342.6 290.93 383.05 314.28 383.05 314.28 382.99 332.6 342.55 309.25",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "342.62 285.91 342.67 267.58 383.11 290.94 383.11 290.94 383.06 309.26 342.62 285.91",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "387.5 288.44 430.43 263.49 430.27 320 387.33 344.95 387.5 288.44",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "387.5 288.44 338.32 260.05 381.25 235.1 430.43 263.49 387.5 288.44",
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-48"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M395.86,255.69c-6.94-4-18.16-4-25.06,0s-6.86,10.51.08,14.51,18.17,4,25.06,0S402.8,259.7,395.86,255.69Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.84,239.07l-14,.41-14-.41c-.61,9.44,1.24,19.07,3.78,23.77h0a6.3,6.3,0,0,0,2.77,2.81,16.36,16.36,0,0,0,14.89,0,6.18,6.18,0,0,0,2.77-2.89C396.62,258,398.44,248.47,397.84,239.07Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.71,233.35c5.48,3.16,5.51,8.29.07,11.45s-14.3,3.16-19.78,0-5.5-8.29-.06-11.45S388.24,230.18,393.71,233.35Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.55,234.6c4.27,2.47,4.29,6.47.05,8.94a17,17,0,0,1-15.43,0c-4.27-2.47-4.3-6.47-.05-8.94A17.05,17.05,0,0,1,391.55,234.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.69,239.47a9.22,9.22,0,0,0,8.2,1.86,8.58,8.58,0,0,0,5.75-5.81,17,17,0,0,1-4.49-3.11,11.49,11.49,0,0,1,6.36.22,6.49,6.49,0,0,0,.48-6.06,11.05,11.05,0,0,0-7.58-.52,10,10,0,0,1,7.66-2.42,29.42,29.42,0,0,0-1.84-11.78c-5.21.28-10.27,2.52-12,4.14a19,19,0,0,0,.58,5.54,4.48,4.48,0,0,1-2.43-3.58c-3.26.81-4.65,2.44-5.16,3.68a13.63,13.63,0,0,0,3.09,6.26c-3.07-.93-4.31-4.34-4.31-4.34C374,230.69,374.59,238.77,382.69,239.47Z",
    style: {
      fill: "#28A745"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.69,239.47a9.22,9.22,0,0,0,8.2,1.86,8.58,8.58,0,0,0,5.75-5.81,17,17,0,0,1-4.49-3.11,11.49,11.49,0,0,1,6.36.22,6.49,6.49,0,0,0,.48-6.06,11.05,11.05,0,0,0-7.58-.52,10,10,0,0,1,7.66-2.42,29.42,29.42,0,0,0-1.84-11.78c-5.21.28-10.27,2.52-12,4.14a19,19,0,0,0,.58,5.54,4.48,4.48,0,0,1-2.43-3.58c-3.26.81-4.65,2.44-5.16,3.68a13.63,13.63,0,0,0,3.09,6.26c-3.07-.93-4.31-4.34-4.31-4.34C374,230.69,374.59,238.77,382.69,239.47Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.51,240.24h0a.3.3,0,0,1-.28-.32c.5-6.59,4.26-17.45,13.24-26.42a.3.3,0,0,1,.43.43c-8.86,8.85-12.58,19.55-13.07,26A.3.3,0,0,1,382.51,240.24Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385,243a8.55,8.55,0,0,1-13.38-3.52,14.62,14.62,0,0,0,4.05-2.76,11.56,11.56,0,0,0-6,.18,5.61,5.61,0,0,1-.84-5.4,11.07,11.07,0,0,1,7.16-.43,10.57,10.57,0,0,0-7.43-2.2,23.92,23.92,0,0,1,1-10.51c5,.3,9.88,2.36,11.59,3.81a15.77,15.77,0,0,1-.2,4.92,3.6,3.6,0,0,0,2.06-3.16c3.11.75,4.52,2.21,5.07,3.31a10.87,10.87,0,0,1-2.51,5.52,6.14,6.14,0,0,0,3.76-3.81C392.54,235.26,392.49,242.38,385,243Z",
    style: {
      fill: "#28A745"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.17,243.71a.3.3,0,0,1-.29-.26c-.86-5.73-5-15.25-13.95-23.2a.3.3,0,0,1,0-.42.29.29,0,0,1,.42,0c9.05,8.06,13.27,17.73,14.14,23.56a.31.31,0,0,1-.25.35Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Device--inject-48"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M196,49.37h0c-.78-2.74-6.34-8-11.87-7.84a4.82,4.82,0,0,0-1.56.31L75.11,103a10.45,10.45,0,0,0-5.2,8.94V344.46c0,5.92,6.83,11.57,13.25,8.85l0,0a2.9,2.9,0,0,0,.41-.16l107.51-61.26a10.28,10.28,0,0,0,5.19-8.94V50.49A2.44,2.44,0,0,0,196,49.37Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.91,136.5a5.13,5.13,0,0,1,2.6-4.46l99.81-56.79a2.57,2.57,0,0,1,3.85,2.23V265a5.15,5.15,0,0,1-2.6,4.46L88.75,326.33a2.57,2.57,0,0,1-3.84-2.23Z",
    style: {
      fill: "#28A745"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.91,136.5a5.13,5.13,0,0,1,2.6-4.46l99.81-56.79a2.57,2.57,0,0,1,3.85,2.23V265a5.15,5.15,0,0,1-2.6,4.46L88.75,326.33a2.57,2.57,0,0,1-3.84-2.23Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.91,111.93V344.46c0,5.92,6.83,11.57,13.25,8.85l0,0a2.55,2.55,0,0,1-3.43-2.4V118.35a10.27,10.27,0,0,1,1.73-5.68L71,107.42A10.19,10.19,0,0,0,69.91,111.93Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.17,41.52a4.82,4.82,0,0,0-1.56.31L75.11,103A10.2,10.2,0,0,0,71,107.42l10.52,5.25A10.31,10.31,0,0,1,85,109.42l107.5-61.16A2.54,2.54,0,0,1,196,49.37h0C195.26,46.62,189.7,41.41,184.17,41.52Z",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.29,86.65c.75-.43,1.38-.09,1.38.77a3.05,3.05,0,0,1-1.37,2.38L130.2,102c-.75.44-1.36.07-1.36-.8a3,3,0,0,1,1.36-2.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.78,102c.75-.44,1.36-.09,1.37.78a3.06,3.06,0,0,1-1.36,2.37c-.76.43-1.38.08-1.38-.79A3,3,0,0,1,124.78,102Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.28,84.88c1.51-.87,2.73-.18,2.73,1.56a6,6,0,0,1-2.71,4.73c-1.51.88-2.76.16-2.77-1.57A6.05,6.05,0,0,1,138.28,84.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.29,303.79c3.07-1.77,5.55-.36,5.56,3.17a12.28,12.28,0,0,1-5.53,9.65c-3.07,1.77-5.61.32-5.62-3.21A12.28,12.28,0,0,1,138.29,303.79Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Screen--inject-48"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M215.71,89.26h0C215,86.77,210,82,204.94,82.14a4.56,4.56,0,0,0-1.41.27L106,137.93a9.48,9.48,0,0,0-4.72,8.11V357.11c0,5.38,6.2,10.51,12,8l0,0a2,2,0,0,0,.38-.15l97.58-55.61a9.33,9.33,0,0,0,4.71-8.11v-211A2.26,2.26,0,0,0,215.71,89.26Z",
    style: {
      fill: "#28A745"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.23,146V357.11c0,5.38,6.2,10.51,12,8l0,0a2.32,2.32,0,0,1-3.11-2.18V151.88a9.33,9.33,0,0,1,1.57-5.16L102.2,142A9.33,9.33,0,0,0,101.23,146Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.94,82.14a4.56,4.56,0,0,0-1.41.27L106,137.93a9.26,9.26,0,0,0-3.75,4l9.55,4.77a9.42,9.42,0,0,1,3.15-3l97.57-55.51a2.32,2.32,0,0,1,3.24,1h0C215,86.77,210,82,204.94,82.14Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.71,89.26h0C215,86.77,210,82,204.94,82.14a4.56,4.56,0,0,0-1.41.27L106,137.93a9.48,9.48,0,0,0-4.72,8.11V357.11c0,5.38,6.2,10.51,12,8l0,0a2,2,0,0,0,.38-.15l97.58-55.61a9.33,9.33,0,0,0,4.71-8.11v-211A2.26,2.26,0,0,0,215.71,89.26Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.74,113.36c.93-.54,1.69-.11,1.7,1l0,10.28a3.75,3.75,0,0,1-1.69,2.93l-63.52,36.63c-.94.54-1.69.11-1.7-1l0-10.29a3.74,3.74,0,0,1,1.69-2.93Z",
    style: {
      fill: "#28A745"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.7000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M181.74,113.36c.93-.54,1.69-.11,1.7,1l0,10.28a3.75,3.75,0,0,1-1.69,2.93l-63.52,36.63c-.94.54-1.69.11-1.7-1l0-10.29a3.74,3.74,0,0,1,1.69-2.93Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M207.05,102.46c2.18-1.26,3.95-.25,4,2.25a7.41,7.41,0,0,1-.65,2.88l.66,1.65-1.69.16a7.31,7.31,0,0,1-2.26,2.12c-2.17,1.26-3.94.25-3.95-2.25A8.64,8.64,0,0,1,207.05,102.46Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M192.63,117.92c.5-.28.91-.06.91.52a2,2,0,0,1-.9,1.56c-.5.28-.9,0-.9-.52A2,2,0,0,1,192.63,117.92Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.13,115.33c.5-.29.9-.06.91.51a2,2,0,0,1-.91,1.56c-.49.29-.9.06-.9-.52A2,2,0,0,1,197.13,115.33Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "199.01 107.26 198.34 114.21 191.43 118.2 190.71 112.06 199.01 107.26",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M116.94,247a4.54,4.54,0,0,1,2.28-3.93L207,193.08a2.26,2.26,0,0,1,3.38,2v42.35a4.55,4.55,0,0,1-2.29,3.93l-87.8,50a2.26,2.26,0,0,1-3.38-2Z",
    style: {
      fill: "#28A745"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.94,247a4.54,4.54,0,0,1,2.28-3.93L207,193.08a2.26,2.26,0,0,1,3.38,2v42.35a4.55,4.55,0,0,1-2.29,3.93l-87.8,50a2.26,2.26,0,0,1-3.38-2Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "155.13 228.03 155.24 267.01 121.32 286.59 121.21 247.62 155.13 228.03",
    style: {
      fill: "#28A745"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "155.13 228.03 155.24 267.01 121.32 286.59 121.21 247.62 155.13 228.03",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001,
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "177.43 231.34 177.44 233.81 159.03 244.41 159.02 241.94 177.43 231.34",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "200 214.17 200.01 216.63 159.02 240.3 159.01 237.83 200 214.17",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "184.5 247.68 184.51 250.15 159.03 264.77 159.02 262.31 184.5 247.68",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "190.81 239.72 190.82 242.18 159.02 260.66 159.01 258.19 190.81 239.72",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "199.99 210.05 200 212.51 159 236.18 159 233.72 199.99 210.05",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "181.04 214.06 181.05 217.61 158.99 230.35 158.98 226.81 181.04 214.06",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M139,249.55c3.73-2.15,6.76-.41,6.78,3.87a14.83,14.83,0,0,1-6.73,11.65c-3.73,2.16-6.77.43-6.78-3.85A14.87,14.87,0,0,1,139,249.55Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134,242.89l10-5.75,0,8.8a7.26,7.26,0,0,0-5,1.13,16.82,16.82,0,0,0-5,4.62Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.94,190.71a4.54,4.54,0,0,1,2.28-3.93L207,136.83a2.26,2.26,0,0,1,3.38,2v42.35a4.55,4.55,0,0,1-2.29,3.93l-87.8,50a2.26,2.26,0,0,1-3.38-2Z",
    style: {
      fill: "#28A745"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.94,190.71a4.54,4.54,0,0,1,2.28-3.93L207,136.83a2.26,2.26,0,0,1,3.38,2v42.35a4.55,4.55,0,0,1-2.29,3.93l-87.8,50a2.26,2.26,0,0,1-3.38-2Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.94,301.92a4.51,4.51,0,0,1,2.28-3.93L207,248a2.26,2.26,0,0,1,3.38,2v42.34a4.53,4.53,0,0,1-2.29,3.93l-87.8,50a2.26,2.26,0,0,1-3.38-2Z",
    style: {
      fill: "#28A745"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.94,301.92a4.51,4.51,0,0,1,2.28-3.93L207,248a2.26,2.26,0,0,1,3.38,2v42.34a4.53,4.53,0,0,1-2.29,3.93l-87.8,50a2.26,2.26,0,0,1-3.38-2Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "155.13 282.99 155.24 321.97 121.32 341.55 121.21 302.57 155.13 282.99",
    style: {
      fill: "#28A745"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "155.13 282.99 155.24 321.97 121.32 341.55 121.21 302.57 155.13 282.99",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001,
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "177.43 286.3 177.44 288.76 159.03 299.36 159.02 296.9 177.43 286.3",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "200 269.12 200.01 271.58 159.02 295.25 159.01 292.79 200 269.12",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "184.5 302.64 184.51 305.1 159.03 319.73 159.02 317.26 184.5 302.64",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "190.81 294.68 190.82 297.14 159.02 315.61 159.01 313.15 190.81 294.68",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "199.99 265 200 267.47 159 291.13 159 288.67 199.99 265",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "181.04 269.02 181.05 272.57 158.99 285.31 158.98 281.76 181.04 269.02",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M149.42,300.8c.73-.42,1.29,0,1.18.9l-1.93,15.87a5.34,5.34,0,0,1-2.36,3.7L131,330.11c-1.18.68-2.18.27-2.36-1l-2-13.59a2.56,2.56,0,0,1,1.17-2.26l4.58-2.64v3.19l1.2-.68V310l10.08-5.82v3.2l1.2-.7v-3.2Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.58,298.32c3.43-2,6.24-.39,6.25,3.56v4.76l-1.2.7v-4.77c0-3.19-2.27-4.49-5-2.88a11.09,11.09,0,0,0-5,8.7v4.77l-1.2.68v-4.76A13.68,13.68,0,0,1,138.58,298.32Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.75,197.7a5.14,5.14,0,0,1,2.6-4.47l99.82-56.79a2.57,2.57,0,0,1,3.84,2.24v48.14a5.15,5.15,0,0,1-2.6,4.46L128.6,248.16a2.57,2.57,0,0,1-3.85-2.23Z",
    style: {
      fill: "#28A745"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.75,197.7a5.14,5.14,0,0,1,2.6-4.47l99.82-56.79a2.57,2.57,0,0,1,3.84,2.24v48.14a5.15,5.15,0,0,1-2.6,4.46L128.6,248.16a2.57,2.57,0,0,1-3.85-2.23Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "168.17 176.19 168.29 220.49 129.74 242.75 129.61 198.45 168.17 176.19",
    style: {
      fill: "#28A745"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "168.17 176.19 168.29 220.49 129.74 242.75 129.61 198.45 168.17 176.19",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M160.71,190l0,8.74a5.24,5.24,0,0,1-2.38,4.11c-1.31.76-2.38.15-2.39-1.36l0-8.5Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.93,205.33a40.79,40.79,0,0,1-1.19,7.21l-6.64,3.84c.19-1.9.37-3.81.55-5.71a73.21,73.21,0,0,1-8,9.27,19.47,19.47,0,0,1-3.8,2.9L133.48,230a1.4,1.4,0,0,1-.49-.93l12.47-7.19a19.39,19.39,0,0,0,3.4-2.54,78.54,78.54,0,0,0,9.42-10.19Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.56,188.92c.14,1.46.41,6.87.74,8.1s.75,2.44,1.19,3.67a12.34,12.34,0,0,1,.44,4.64l-6.65,3.84a78.54,78.54,0,0,1-9.42,10.19,19.39,19.39,0,0,1-3.4,2.54L133,229.09a6.87,6.87,0,0,1,.94-4.15,16.57,16.57,0,0,1,3.66-3.87,48.52,48.52,0,0,0,4.93-5c4.23-4.87,9.11-11.76,10.73-21.4.78-.46,1.71-1,2.7-1.65l0,8.5c0,1.51,1.08,2.12,2.39,1.36a5.24,5.24,0,0,0,2.38-4.11l0-8.74C161.38,189.63,162,189.24,162.56,188.92Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001,
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "193.52 179.94 193.53 182.75 172.6 194.8 172.59 192 193.52 179.94",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "219.18 160.42 219.19 163.22 172.59 190.12 172.58 187.32 219.18 160.42",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "201.56 198.52 201.56 201.32 172.6 217.94 172.59 215.14 201.56 198.52",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "208.73 189.47 208.74 192.27 172.59 213.27 172.58 210.47 208.73 189.47",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "219.17 155.74 219.17 158.54 172.57 185.44 172.57 182.64 219.17 155.74",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "197.63 160.3 197.64 164.34 172.56 178.82 172.54 174.79 197.63 160.3",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.8
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "131.94 163.41 129.19 174.85 126.6 176.35 124.94 171.31 123.25 178.28 120.65 179.78 117.84 171.55 120.33 170.11 122.08 175.39 123.87 168.07 126.1 166.78 127.84 172.13 129.63 164.75 131.94 163.41",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "135.24 161.5 135.27 171.34 132.84 172.74 132.81 162.91 135.24 161.5",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.31,158.38a5.87,5.87,0,0,1,3.1-.94l-.73,2.5a4.34,4.34,0,0,0-2.38.61c-1,.59-1.38,1.19-1.38,1.68,0,1.51,4.86-2.42,4.87,1.21,0,1.71-1.24,3.9-3.78,5.37a5.82,5.82,0,0,1-3.62,1l.79-2.5a4.48,4.48,0,0,0,2.83-.66c1-.59,1.39-1.14,1.39-1.61,0-1.56-4.87,2.39-4.88-1.28C136.52,162,137.76,159.85,140.31,158.38Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "153.04 151.23 153.06 161.06 150.64 162.47 150.63 158.63 147.33 160.54 147.34 164.37 144.92 165.77 144.89 155.93 147.32 154.53 147.33 158.23 150.62 156.32 150.61 152.63 153.04 151.23",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "157.18 148.84 157.2 156.47 161.29 154.11 161.29 156.31 154.78 160.07 154.75 150.24 157.18 148.84",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "164.66 144.52 164.68 154.36 162.26 155.76 162.23 145.92 164.66 144.52",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.71,141.4a5.86,5.86,0,0,1,3.12-.94l-.74,2.49a4.51,4.51,0,0,0-2.38.62c-1,.58-1.37,1.18-1.37,1.68,0,1.51,4.86-2.42,4.87,1.21,0,1.71-1.24,3.89-3.79,5.36a5.77,5.77,0,0,1-3.62,1l.79-2.5a4.46,4.46,0,0,0,2.84-.67c1-.57,1.39-1.13,1.39-1.6,0-1.57-4.88,2.39-4.89-1.27C165.93,145,167.17,142.87,169.71,141.4Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "181.05 135.06 181.05 137.26 178.43 138.78 178.45 146.41 176.03 147.8 176.01 140.17 173.38 141.69 173.37 139.49 181.05 135.06",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "211.55 118.87 211.56 122.91 186.48 137.39 186.47 133.36 211.55 118.87",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "205 128.13 205.01 132.16 186.48 142.86 186.47 138.83 205 128.13",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M134.1,268.7a7.33,7.33,0,0,0,5-1.13,17,17,0,0,0,5-4.62l0,8.79-10,5.75Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144,245.94c2.38.46,4,2.68,4,6.23A19.11,19.11,0,0,1,144.07,263a17,17,0,0,1-5,4.62,7.33,7.33,0,0,1-5,1.13c-2.38-.48-3.95-2.69-4-6.23a19.11,19.11,0,0,1,3.92-10.78,16.82,16.82,0,0,1,5-4.62A7.26,7.26,0,0,1,144,245.94Zm-4.93,19.13a14.83,14.83,0,0,0,6.73-11.65c0-4.28-3-6-6.78-3.87a14.87,14.87,0,0,0-6.73,11.67c0,4.28,3.05,6,6.78,3.85",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-48"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M265.15,428.3c-.74,1.55-3.09,3-5.66,3.41s-5.19-.13-7.77-.49a51.07,51.07,0,0,0-11.59-.3,62.26,62.26,0,0,1-7.21.52,11.45,11.45,0,0,1-6.78-2.15,6.89,6.89,0,0,1-2.55-4.33,6.54,6.54,0,0,0,2.55,5.84,11.51,11.51,0,0,0,6.78,2.15,62.26,62.26,0,0,0,7.21-.52,51.07,51.07,0,0,1,11.59.3c2.58.36,5.38,1.1,8,.67s4.92-1.86,5.66-3.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237,423.71c2.16,0,1.37-3.2,3.43-5.34-.84.05-1.68.06-2.52.06C236.07,421.09,235.55,423.71,237,423.71Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.5,423.55c2.18,0,1.61-3.82,3.75-6.05a13.28,13.28,0,0,1-1.49.43c-.42.1-.85.17-1.28.23C240.57,420.86,240,423.55,241.5,423.55Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.91,416.23a2.91,2.91,0,0,0-1.12-1.76l-11.69-.29a10.05,10.05,0,0,1-4.85,3.32c-2.14,2.23-1.57,6.05-3.75,6.05-1.48,0-.93-2.69,1-5.39q-1,.15-2,.21c-2.06,2.14-1.27,5.34-3.43,5.34-1.46,0-.94-2.62.91-5.28l-1.64,0c-.5,0-1,0-1.49-.08-4.3,3.4-4.67,7.09-4.11,12.87a15.34,15.34,0,0,0,2.24.24,62.26,62.26,0,0,0,7.21-.52,51.07,51.07,0,0,1,11.59.3c2.58.36,5.2.92,7.77.49s4.92-1.86,5.66-3.41Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.79,418.33a18.51,18.51,0,0,0-5.85,0c-2.37.58-4.64,2.21-5.26,4.58a5.06,5.06,0,0,0-.09,2,6.89,6.89,0,0,0,2.55,4.33,10,10,0,0,0,4.54,1.91C230.12,425.42,230.49,421.73,234.79,418.33Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.76,410.85v5.63a2.31,2.31,0,0,0,2.32,2.31H258a3.8,3.8,0,0,0,3.8-3.67l.14-4.27Z",
    style: {
      fill: "#9c5a5a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.72,408.34a4.35,4.35,0,0,1-3.55,2.49,7.48,7.48,0,0,1-4.49-1.11c-2-1.29-2.82-3.31-4.2-5.14a30.66,30.66,0,0,0-4.89-4.77,16.17,16.17,0,0,1-4.67-5.42,7.11,7.11,0,0,1-.55-2,7,7,0,0,0,.55,3.81,16.14,16.14,0,0,0,4.67,5.41,30.72,30.72,0,0,1,4.89,4.78c1.38,1.82,2.17,3.85,4.2,5.14a7.54,7.54,0,0,0,4.49,1.1,4.34,4.34,0,0,0,3.55-2.48,9.84,9.84,0,0,0,.21-3.14A4,4,0,0,1,288.72,408.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.44,396a1.44,1.44,0,0,0-.29,1,1,1,0,0,0,.64.72,1.37,1.37,0,0,0,1.31-.34,6.82,6.82,0,0,0,.92-1.08,6.85,6.85,0,0,1,3-2.2,7,7,0,0,1,1.8-.39l-1.46-1.34a7.25,7.25,0,0,0-5.92,3.66Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.75,391.34a7.34,7.34,0,0,0-3.26,3,1.43,1.43,0,0,0-.29,1,1,1,0,0,0,.64.73,1.39,1.39,0,0,0,1.32-.34,6.76,6.76,0,0,0,.91-1.08,6.78,6.78,0,0,1,6-2.59l-1.45-1.32A7.32,7.32,0,0,0,275.75,391.34Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.66,389.87a15.06,15.06,0,0,0-4.59-3.06c-2.09-.8-4.69-.68-6.3.87a5.41,5.41,0,0,0-1.4,4.73,7.11,7.11,0,0,0,.55,2,10.51,10.51,0,0,0,1.45,2.3C268.93,391.66,273.3,389.3,278.66,389.87Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.83,403.41a10.49,10.49,0,0,0-1.14-4.93l-2.84-3-2-1.84a7,7,0,0,0-1.8.39,6.85,6.85,0,0,0-3,2.2,6.82,6.82,0,0,1-.92,1.08,1.37,1.37,0,0,1-1.31.34,1,1,0,0,1-.64-.72,1.44,1.44,0,0,1,.29-1,7.25,7.25,0,0,1,5.92-3.66L281,392a6.78,6.78,0,0,0-6,2.59,6.76,6.76,0,0,1-.91,1.08,1.39,1.39,0,0,1-1.32.34,1,1,0,0,1-.64-.73,1.43,1.43,0,0,1,.29-1,7.29,7.29,0,0,1,7.09-3.64l-.05,0-.87-.79c-5.36-.57-9.73,1.79-10.29,6.82a24.36,24.36,0,0,0,3.22,3.12,30.66,30.66,0,0,1,4.89,4.77c1.38,1.83,2.17,3.85,4.2,5.14a7.48,7.48,0,0,0,4.49,1.11,4.35,4.35,0,0,0,3.55-2.49,4,4,0,0,0,.21-1.31A34.76,34.76,0,0,0,288.83,403.41Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.58,394.5l.33,6.05c3.82,2.2,7.83,1,9.16-.39l.25-5.66Z",
    style: {
      fill: "#9c5a5a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.09,263.87a5.57,5.57,0,0,1-.58-2.08l-.32-5.19-37,2.38c-.49,2.59-1,5.77-1.47,9.36A55,55,0,0,0,286.09,263.87Z",
    style: {
      fill: "#9c5a5a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.37,242.94l7.87,15.21-7.15,12,7.91,12.5,11.94-18.53a10.42,10.42,0,0,0,1.22-8.56,145.88,145.88,0,0,0-7.76-21.12Z",
    style: {
      fill: "#9c5a5a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.11,213.56c9.06-1.68,14.24,1.34,21.9,21.83-3.13,7-16.4,9.6-16.4,9.6Z",
    style: {
      fill: "#28A745"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.11,213.56c9.06-1.68,14.24,1.34,21.9,21.83-3.13,7-16.4,9.6-16.4,9.6Z",
    style: {
      opacity: 0.3
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.15,216l-9.89,1.95c-2.19,4-4.42,7.76-6.6,11.76-1.65,3-3.34,6.21-3.22,9.64a9.84,9.84,0,0,0,5.92,8.53l-1.14,13.5c15.53,4.75,34.52.58,38.69-3,1.22-5.66,2.31-11.68,3.54-17.34a59.37,59.37,0,0,0,1.67-11.14A19.65,19.65,0,0,0,288.51,219l-.06-.1a12.1,12.1,0,0,0-12.14-5.21Z",
    style: {
      fill: "#28A745"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.67,264.82a6.19,6.19,0,0,1-.58-.95,55,55,0,0,1-39.33,4.47c-2.78,20.74-5.18,55.85-3.71,79,1.22,27,6.19,65.15,6.19,65.15,6.47,1.94,11.32.75,13.15-.65,2.16-26.75,6.91-45.08,3.24-62.77,2.45-12.37,4-27.9,4-27.9l1.87,27.32,6.32,48a11.35,11.35,0,0,0,11.37-.57c4.6-27.47,6.32-46.08,2.3-59.71C297.66,291.17,298,279.64,286.67,264.82Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.38,315.78l3.39-14.23c4-.65,10.14-3.24,13.39-8.67a27.18,27.18,0,0,1-16.41,5.79l-3.09,22.51.66,9.61.26-3.5A74.49,74.49,0,0,1,272.38,315.78Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.58,199.69l9.95,25.75a10.27,10.27,0,0,0,7.82,6.42l17,3a15.08,15.08,0,0,0,3-16,81.64,81.64,0,0,1-15.33-1.68s-10.75-13.08-15.24-19.83l3.2-10.61a3.63,3.63,0,0,0-.32-2.88l-1.72-3a3.68,3.68,0,0,0-2-1.64l-2.48-.85a4.36,4.36,0,0,0-3.43.27l-3.78,2a1.45,1.45,0,0,0-.78,1.31h0a1.46,1.46,0,0,0,.78,1.27l1.42.73,2,3.32A10.47,10.47,0,0,0,188.58,199.69Z",
    style: {
      fill: "#9c5a5a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.71,217.74c-6.12.29-15.31,1.3-24.33,1.12a15.08,15.08,0,0,1-3,16l21.24,3.71a9.14,9.14,0,0,0,10.27-6.73c.66-2.69,1.37-4.95,1.77-7.57A5.69,5.69,0,0,0,250.71,217.74Z",
    style: {
      fill: "#28A745"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.71,217.74c-6.12.29-15.31,1.3-24.33,1.12a15.08,15.08,0,0,1-3,16l21.24,3.71a9.14,9.14,0,0,0,10.27-6.73c.66-2.69,1.37-4.95,1.77-7.57A5.69,5.69,0,0,0,250.71,217.74Z",
    style: {
      opacity: 0.3
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.1,189.39a17.18,17.18,0,0,1-1.94-9.11,9.8,9.8,0,0,1,4.78-7.7c2.77-1.48,6.62-1,8.55,1.5,5.1-2.54,11.49-2.58,16.23.58A16.63,16.63,0,0,1,285,189.29c-.21,3.27-1.41,6.49-1,9.75.21,1.92,1,3.86.47,5.72a5.9,5.9,0,0,1-3.11,3.52c-1.43.75-4.77.55-6.35.88-4.82,4.38-10.88,2.74-14.73-1.17S250.1,189.39,250.1,189.39Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "249.1 193.74 246.09 198.97 249.38 200.19 249.1 193.74",
    style: {
      fill: "#804040"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.76,191.41c.48-4.59,1.82-8.92,4.81-11.12A24.8,24.8,0,0,0,257,196.72a7.14,7.14,0,0,1,2.22-3.93,4.15,4.15,0,0,1,4.28-.92,4.24,4.24,0,0,1,2.15,2.35,5.57,5.57,0,0,1-7,7.36,10.72,10.72,0,0,0,8.23,8.34,13.78,13.78,0,0,0,8-.76l1.24,6.19c-5,5.37-13.64,1.76-13.64,1.76L261.38,211c-9.91.59-10.83.42-11.92-5A53.44,53.44,0,0,1,248.76,191.41Z",
    style: {
      fill: "#9c5a5a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.7,184.74a17.42,17.42,0,0,1,7.88-9.42,16.64,16.64,0,0,1,6.37,14c-.21,3.27-1.41,6.49-1,9.75.21,1.92,1,3.86.47,5.72a5.9,5.9,0,0,1-3.11,3.52c-1.43.75-4.77.55-6.35.88-.21.19-.42.35-.64.52a48.91,48.91,0,0,1-3.92-10.06A25.82,25.82,0,0,1,270.7,184.74Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.45,181.3a12.62,12.62,0,0,1,24.07-.29c3,9-4.67,18.66-3,28,.6,3.38,2.39,6.46,3,9.83A14.58,14.58,0,0,1,285,236c2.15-2.37,2.19-6,1-9s-3.41-5.39-5.3-8C273,208.54,269.7,193.66,273.45,181.3Z",
    style: {
      fill: "#37474f"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategoriesAdmin);
export default __webpack_public_path__ + "static/media/categoriesAdmin.8144bb03b0d031d61783fa78bb684c27.svg";
export { ForwardRef as ReactComponent };